import axios from "axios";
import C from "@/utils/constants";
import inter from "@/utils/shared";
import router from "@/router/index";
// import JSONbig from 'json-bigint';
// const JSONbigToString = JSONbig({ storeAsString: false })
axios.defaults.withCredentials = true;

const server = axios.create({
  baseURL: C.ApiUrl,
});

/**
 * 请求拦截器
 */
server.interceptors.request.use(
  function (config: any) {
    /**
     * token是携带在请求头上的
     */
    // @ts-ignore
    let token = localStorage.getItem("accessToken");
    if (token) {
      if (config.url.indexOf("?") != -1) {
        config.urlTire = config.url;
        config.url = `${config.url}&.=${token}`;
      } else {
        config.urlTire = config.url;
        config.url = `${config.url}?.=${token}`;
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截器
 */
server.interceptors.response.use(
  function (response: any) {
    if (response.data.errorCode === 2005) {
      return Promise.reject();
    }
    return response.data
  },
  function (error: any) {
    switch (error.response.status) {
      /**
       * 针对错误返回的同意处理
       */
      case 403:
        inter.errorReminder("error", "提示", error.response.data.errorMessage);
        break;
      case 500:
        inter.errorReminder("error", "提示", error.response.data.errorMessage);
        break;
      case 401:
        // token过期
        // Toast(error.response.data.msg)
        // router.push('/login')

        if (error.response.data.errorCode === 401) {
          return inter
            .holdUp()
            .then((res: any) => {
              let token = res.data.accessToken; //localStorage.getItem('accessToken')
              let urlRefresh = "";
              if (token) {
                if (error.response.config.urlTire.indexOf("?") != -1) {
                  urlRefresh = `${error.response.config.urlTire}&.=${token}`;
                } else {
                  urlRefresh = `${error.response.config.urlTire}?.=${token}`;
                }
              }
              error.response.config.url = urlRefresh;
              return server(error.response.config);
            })
            .catch(() => {
              // router.push()
            });
        } else if (error.response.data.errorCode === 402 || error.response.data.code === 401) {
          // @ts-ignore
          localStorage.removeItem("accessToken");
          // @ts-ignore
          localStorage.removeItem("refreshToken");
          // @ts-ignore
          localStorage.removeItem("user");
          router.replace("/login");
        }
        break;
      default:
        inter.errorReminder(
          "error",
          "提示",
          error.response.data?.errorMessage || "网络异常"
        );
    }
    return Promise.reject(Error);
  }
);

export default server;
